import script from "./nav-tabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./nav-tabs.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__